import axios from 'axios';

export const API_BASE = process.env.REACT_APP_API_BASE || 'https://api.duckly.info/dev';

const client = axios.create({ baseURL: API_BASE, timeout: 30000 });

export interface NftTraits {
    [key: string]: string | number | null;
}

export interface Nft {
    identifier: string;
    collection: string;
    contract?: string;
    name?: string;
    image_url?: string;
    opensea_url?: string;
    traits: NftTraits | null;
}

export interface Listing {
    chain?: string;
    priceToken: number;
    priceDollars: string | null;
    price: { current: { currency: string; value: string; decimals: number } };
    nft: Nft;
}

export interface StatsInterval {
    interval: string;
    volume: number;
    sales?: number;
}

export interface CollectionStats {
    total?: {
        floor_price?: number;
        floor_price_symbol?: string;
        market_cap?: number;
        num_owners?: number;
        volume?: number;
        sales?: number;
    };
    intervals?: StatsInterval[];
}

export type WalletInventory = Record<string, Nft[]>;

export const getListings = async (collectionPath: string): Promise<Listing[]> =>
    (await client.get(`/${collectionPath}/list/listings`)).data;

export const getStatistics = async (collectionPath: string): Promise<CollectionStats> =>
    (await client.get(`/${collectionPath}/statistics`)).data;

export const getWalletItems = async (walletAddress: string): Promise<WalletInventory> =>
    (await client.get('/wallet/list_collections', { params: { walletAddress } })).data;

export const describeApiError = (error: unknown): string => {
    if (axios.isAxiosError(error)) {
        const message = (error.response?.data as { message?: string } | undefined)?.message;
        if (message) return String(message);
        if (error.code === 'ECONNABORTED') return 'The request timed out. Please try again.';
        if (error.request && !error.response) return 'Could not reach the duckly.info API. Check your connection.';
        return error.message;
    }
    return 'Unexpected error';
};

export const isUpstreamKeyError = (message: string): boolean => /api key/i.test(message);
